import type { FollowerAbility } from '../../../schemas/follower';

/**
 * Abilità **Menestrello** (manuale V1, rr. 1386-1400).
 *
 * Faccia sorridente per accordi e contatti sociali in luoghi civilizzati.
 */
export const menestrello: FollowerAbility = {
  id: 'menestrello',
  label: 'Menestrello',
  description:
    "Non puoi farne a meno quando serve una faccia sorridente per fare un accordo o uscire dai guai (finendo spesso dalla padella nella brace). Come tutte le 'star', però, ha le sue pretese...",
  ranks: [
    {
      rank: 1,
      trigger: "Quando *fai baldoria* e un Menestrello è l'anima della festa",
      description:
        'Il costo in monete per attivare la mossa (ma non quello per ottenere bonus al tiro), è azzerato. Il gregario può usare questa mossa una sola volta per sessione.',
    },
    {
      rank: 2,
      trigger:
        'Quando arrivi in un luogo civilizzato e chiedi a un Menestrello di darti una mano tramite i suoi contatti',
      description:
        "Può farlo in molti modi. Digli cosa ti serve, e lui te lo farà ottenere:\n\n- qualcuno che, nonostante tutto, potrebbe essere disposto ad aiutarti;\n- qualcosa di inconsueto (prendi +1 al prossimo tiro per *fare rifornimento*);\n- un'informazione su qualcosa o qualcuno;\n- dei mercenari (prendi +1 al prossimo tiro per *reclutare*).\n\nIl Menestrello può usare questa mossa una sola volta per centro civilizzato visitato per sessione.",
    },
    {
      rank: 3,
      trigger: 'Quando chiedi a un Menestrello di narrarti una leggenda',
      description:
        'Digli su quale argomento vorresti sentirne una. Se il gregario conosce una leggenda pertinente alla tua richiesta (a discrezione del GM), te la racconta e tu prendi +1 al prossimo tiro per *declamare conoscenze* riguardo qualcosa di cui essa parlava.',
    },
  ],
};
